import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/logo1.png";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer
            style={{
                backgroundColor: "#07162c",
                color: "#ffffff",
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                width: "100%",
                boxSizing: "border-box"
            }}
        >
            <div
                style={{
                    maxWidth: "1180px",
                    margin: "0 auto",
                    padding: "60px 20px 25px",
                    boxSizing: "border-box"
                }}
            >
                {/* =====================================================
                    FOOTER CONTENT
                ===================================================== */}
                <div className="himsal-footer-grid">

                    {/* COMPANY */}
                    <div className="himsal-footer-company">
                        <NavLink
                            to="/"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                textDecoration: "none",
                                color: "#ffffff",
                                marginBottom: "18px"
                            }}
                        >
                            <img
                                src={logo}
                                alt="Himsal Services"
                                style={{
                                    width: "42px",
                                    height: "42px",
                                    objectFit: "contain"
                                }}
                            />

                            <div>
                                <div
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: "800",
                                        lineHeight: "1.1",
                                        color: "#ffffff"
                                    }}
                                >
                                    Himsal
                                </div>

                                <div
                                    style={{
                                        color: "#94a3b8",
                                        fontSize: "9px",
                                        fontWeight: "600",
                                        letterSpacing: "1.2px",
                                        marginTop: "3px"
                                    }}
                                >
                                    SERVICES PVT. LTD.
                                </div>
                            </div>
                        </NavLink>

                        <p
                            style={{
                                color: "#94a3b8",
                                fontSize: "14px",
                                lineHeight: "1.8",
                                maxWidth: "350px",
                                margin: "0 0 20px"
                            }}
                        >
                            Helping businesses build teams, outsource
                            operations and access practical technology
                            solutions through flexible business services.
                        </p>

                        <NavLink
                            to="/contact"
                            style={{
                                display: "inline-block",
                                backgroundColor: "#2563eb",
                                color: "#ffffff",
                                padding: "11px 18px",
                                borderRadius: "7px",
                                textDecoration: "none",
                                fontSize: "13px",
                                fontWeight: "700"
                            }}
                        >
                            Talk to Us →
                        </NavLink>
                    </div>

                    {/* SERVICES */}
                    <div>
                        <h4 className="himsal-footer-title">
                            Services
                        </h4>

                        <div className="himsal-footer-links">
                            <NavLink to="/service" className="himsal-footer-link">
                                Finance & Accounting
                            </NavLink>

                            <NavLink to="/service" className="himsal-footer-link">
                                Staffing & Payroll
                            </NavLink>

                            <NavLink to="/service" className="himsal-footer-link">
                                IT & Technology
                            </NavLink>

                            <NavLink to="/service" className="himsal-footer-link">
                                Web & Software
                            </NavLink>

                            <NavLink to="/service" className="himsal-footer-link">
                                BPO & Managed Services
                            </NavLink>
                        </div>
                    </div>

                    {/* COMPANY LINKS */}
                    <div>
                        <h4 className="himsal-footer-title">
                            Company
                        </h4>

                        <div className="himsal-footer-links">
                            <NavLink to="/" className="himsal-footer-link">
                                Home
                            </NavLink>

                            <NavLink to="/about" className="himsal-footer-link">
                                About Himsal
                            </NavLink>

                            <NavLink to="/service" className="himsal-footer-link">
                                Our Services
                            </NavLink>

                            <NavLink to="/contact" className="himsal-footer-link">
                                Contact Us
                            </NavLink>
                        </div>
                    </div>

                    {/* CONTACT */}
                    <div>
                        <h4 className="himsal-footer-title">
                            Get in Touch
                        </h4>

                        {/* ADDRESS */}
                        <div className="himsal-contact-item">
                            <span className="himsal-contact-icon">
                                📍
                            </span>

                            <span>
                                204, 2nd Floor, Utkarsh Tower,
                                <br />
                                32, Block E, Laxmi Nagar,
                                <br />
                                Delhi - 110092
                            </span>
                        </div>

                        {/* EMAIL */}
                        <a
                            href="mailto:info@himsal.in"
                            className="himsal-contact-link"
                        >
                            <span className="himsal-contact-icon">
                                ✉️
                            </span>

                            <span>info@himsal.in</span>
                        </a>

                        {/* PHONE */}
                        <a
                            href="tel:+919576755755"
                            className="himsal-contact-link"
                        >
                            <span className="himsal-contact-icon">
                                📞
                            </span>

                            <span>+91 9576 755 755</span>
                        </a>

                        {/* WHATSAPP */}
                        <a
                            href="https://wa.me/919576755755"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="himsal-whatsapp"
                        >
                            💬 WhatsApp
                        </a>
                    </div>
                </div>

                {/* =====================================================
                    BOTTOM BAR
                ===================================================== */}
                <div
                    style={{
                        borderTop:
                            "1px solid rgba(255,255,255,0.10)",
                        marginTop: "50px",
                        paddingTop: "20px"
                    }}
                >
                    <div className="himsal-footer-bottom">
                        <p>
                            © {currentYear} Himsal Services Pvt. Ltd. All
                            Rights Reserved.
                        </p>

                        <p>
                            Business • Staffing • Technology
                        </p>
                    </div>
                </div>
            </div>

            {/* =====================================================
                RESPONSIVE CSS
            ===================================================== */}
            <style>
                {`
                    * {
                        box-sizing: border-box;
                    }

                    .himsal-footer-grid {
                        display: grid;
                        grid-template-columns:
                            1.5fr
                            0.7fr
                            0.7fr
                            1fr;
                        gap: 45px;
                    }

                    .himsal-footer-title {
                        color: #ffffff;
                        font-size: 14px;
                        font-weight: 800;
                        margin: 0 0 20px;
                    }

                    .himsal-footer-links {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    .himsal-footer-link {
                        color: #94a3b8;
                        font-size: 13px;
                        text-decoration: none;
                        line-height: 1.5;
                        transition: color 0.2s ease;
                    }

                    .himsal-footer-link:hover {
                        color: #60a5fa;
                    }

                    .himsal-contact-item {
                        display: flex;
                        align-items: flex-start;
                        gap: 10px;
                        color: #94a3b8;
                        font-size: 13px;
                        line-height: 1.6;
                        margin-bottom: 17px;
                    }

                    .himsal-contact-link {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        color: #94a3b8;
                        text-decoration: none;
                        font-size: 13px;
                        margin-bottom: 14px;
                        word-break: break-word;
                    }

                    .himsal-contact-link:hover {
                        color: #60a5fa;
                    }

                    .himsal-contact-icon {
                        color: #60a5fa;
                        flex-shrink: 0;
                    }

                    .himsal-whatsapp {
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        background-color: #25D366;
                        color: #ffffff;
                        padding: 9px 14px;
                        border-radius: 7px;
                        text-decoration: none;
                        font-size: 12px;
                        font-weight: 700;
                        margin-top: 2px;
                    }

                    .himsal-footer-bottom {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 15px;
                        flex-wrap: wrap;
                    }

                    .himsal-footer-bottom p {
                        color: #64748b;
                        font-size: 12px;
                        margin: 0;
                    }

                    /* ================================================
                       TABLET
                    ================================================= */
                    @media (max-width: 900px) {
                        .himsal-footer-grid {
                            grid-template-columns:
                                1.3fr
                                1fr
                                1fr;
                            gap: 35px;
                        }

                        .himsal-footer-company {
                            grid-column: 1 / -1;
                        }
                    }

                    /* ================================================
                       MOBILE
                    ================================================= */
                    @media (max-width: 600px) {
                        .himsal-footer-grid {
                            display: flex;
                            flex-direction: column;
                            gap: 38px;
                        }

                        .himsal-footer-company {
                            width: 100%;
                        }

                        .himsal-footer-title {
                            margin-bottom: 15px;
                        }

                        .himsal-footer-links {
                            gap: 11px;
                        }

                        .himsal-contact-item {
                            max-width: 320px;
                        }

                        .himsal-footer-bottom {
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 8px;
                        }
                    }

                    /* ================================================
                       SMALL MOBILE
                    ================================================= */
                    @media (max-width: 380px) {
                        .himsal-footer-bottom p {
                            font-size: 11px;
                        }

                        .himsal-footer-link,
                        .himsal-contact-link,
                        .himsal-contact-item {
                            font-size: 12px;
                        }
                    }
                `}
            </style>
        </footer>
    );
};

export default Footer;
